import React, { useEffect, useState } from "react";
import {
  useAnimatedValue,
  useAuth,
  AnimatedBlock,
  interpolate,
} from "react-uicomp";
import { AiFillPlayCircle } from "react-icons/all";

// ACTIONs
import { useDispatch, useSelector } from "react-redux";
import { getVideoGallery } from "../../../actions/Actions";

import CompWrapper from "../../hoc/compWrapper/CompWrapper.hoc";
import Title from "../../common/title/Title.common";
import ImageViewer from "../../common/imageViewer/ImageViewer.common";
import ActivityIndicator from "../../hoc/activityIndicator/ActivityIndicator.hoc";

const GALLERY_VIDEO = [
  "vgT9PEf2Gqw",
  "vgT9PEf2Gqw",
  "vgT9PEf2Gqw",
  "vgT9PEf2Gqw",
  "vgT9PEf2Gqw",
];

const GalleryVideo = ({
  thumbnail,
  video,
  setActiveVideo,
  setVideoViewerOpen,
}) => {
  const scale = useAnimatedValue(1);

  return (
    <AnimatedBlock
      onMouseEnter={() => (scale.value = 1.05)}
      onMouseLeave={() => (scale.value = 1)}
      onClick={() => {
        setActiveVideo(video);
        setVideoViewerOpen(true);
      }}
      className="gallery-item">
      <AnimatedBlock
        style={{
          backgroundImage: `url(${thumbnail})`,
          scale: scale.value,
          position: "relative",
        }}
        className="gallery-item-image">
        <AnimatedBlock
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            backgroundColor: interpolate(
              scale.value,
              [1, 1.05],
              ["rgba(0,0,0,0)", "rgba(0,0,0,0.4)"],
            ),
          }}>
          <AnimatedBlock
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              color: "white",
              opacity: interpolate(scale.value, [1, 1.05], [0, 1]),
              scale: interpolate(scale.value, [1, 1.05], [1, 1.5]),
            }}>
            <AiFillPlayCircle size={40} />
          </AnimatedBlock>
        </AnimatedBlock>
      </AnimatedBlock>
    </AnimatedBlock>
  );
};

export const VideoGalleryPage = () => {
  const { setHeaderTitle } = useAuth();
  const [activeVideo, setActiveVideo] = useState(null);
  const [videoViewerOpen, setVideoViewerOpen] = useState(false);

  const dispatch = useDispatch();
  const { videoListLoader, videoList } = useSelector((state) => state.gallery);

  useEffect(() => {
    dispatch(getVideoGallery());
  }, [getVideoGallery]);

  useEffect(() => {
    setHeaderTitle("Video Gallery");
  }, [setHeaderTitle]);

  return (
    <CompWrapper>
      <Title title="Video Gallery" hide_SeeAll />

      <ActivityIndicator animating={videoListLoader}>
        <div className="photo-gallery-container">
          <div className="photo-gallery">
            {videoList?.length ? (
              videoList.map((item, i) => (
                <GalleryVideo
                  key={i}
                  thumbnail={`https://img.youtube.com/vi/${item?.description.link}/0.jpg`}
                  video={item?.description.link}
                  setActiveVideo={setActiveVideo}
                  setVideoViewerOpen={setVideoViewerOpen}
                />
              ))
            ) : (
              <p style={{ textAlign: "center" }}>No Data Available</p>
            )}
          </div>

          <ImageViewer
            open={videoViewerOpen}
            close={setVideoViewerOpen}
            activeImage={activeVideo}
            isVideo={true}
          />
        </div>
      </ActivityIndicator>
    </CompWrapper>
  );
};
